<template>
  <section
    class="grid-table"
    :class="gridName ? 'grid-table__' + gridName : ''"
  >
    <header
      class="grid-table-header grid-table-header__dark mb-1"
      :class="[headerClass,{'disabled': disabled}]"
    >
      <slot name="header" />
    </header>

    <slot
      v-if="!disabled"
      name="rows"
    />
    <ListEmptyWidget v-else />
  </section>
</template>

<script setup lang="ts">
import ListEmptyWidget from '@/components/ui/ListEmptyWidget.vue'

withDefaults(defineProps<{
  disabled?: boolean
  gridName?: string
  headerClass?: string
}>(), {
  disabled: false
})
</script>
